import React, { useState, useCallback, useEffect } from 'react';
import { createFormField } from 'Shared/utils/createFormField';
import { Collapse } from 'reactstrap';
import { Field } from 'react-final-form';
import RadioInput from 'Shared/components/RadioInput/RadioInput';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import FormShareToChat from '../FormShareToChat';
import FormSelectWorkspace from '../FormSelectWorkspace/FormSelectWorkspace';

type Props = {
  value: boolean;
  workspaceIsGroup: boolean;
  workspaceIsDefined: boolean;
  onlyShowPublicOption: boolean;
  onChange: Function;
  nonTeamSyncWorkspacesWithInitialTeammate;
};

function PublicOrPrivate({
  onChange,
  value,
  workspaceIsGroup,
  workspaceIsDefined,
  onlyShowPublicOption,
  nonTeamSyncWorkspacesWithInitialTeammate,
}: Props) {
  const { tr } = useTranslation();
  const [expandedShareWithTeamOptions, setExpandedShareWithTeamOptions] = useState(value);

  const handleShareWithTeamClick = useCallback(() => onChange(true), [onChange]);

  const handleKeepPrivateClick = useCallback(() => onChange(false), [onChange]);

  useEffect(() => {
    setExpandedShareWithTeamOptions(value);
  }, [value]);

  if (onlyShowPublicOption) {
    return (
      <div className="ml-4 mb-2 pl-1">
        <Field name="chatOptions.shareToChat" component={FormShareToChat} />
      </div>
    );
  }

  const nonTeamSyncWorkspacesWithInitialTeammateIsOnlyOneOnOne =
    nonTeamSyncWorkspacesWithInitialTeammate.length === 1 && nonTeamSyncWorkspacesWithInitialTeammate[0].isOneOnOne;

  const keepPrivateLabel = () => {
    if (!workspaceIsDefined) {
      if (nonTeamSyncWorkspacesWithInitialTeammateIsOnlyOneOnOne)
        return tr('perform.modals.give_recognition.private_between_two');
      return tr('perform.modals.give_recognition.private_between_two_or_group');
    }
    return workspaceIsGroup
      ? tr('perform.modals.give_recognition.private_in_group')
      : tr('perform.modals.give_recognition.private_between_two');
  };

  return (
    <>
      <RadioInput
        name="shareWithTeam"
        label={tr('perform.modals.give_recognition.public_option')}
        className="mt-1 mt-sm-0"
        checked={value && value !== null}
        onClick={handleShareWithTeamClick}
      />
      <Collapse isOpen={!!expandedShareWithTeamOptions}>
        <div className="ml-4 mb-2 pl-1">
          <Field name="chatOptions.shareToChat" component={FormShareToChat} />
        </div>
      </Collapse>
      <RadioInput
        name="keepPrivate"
        label={keepPrivateLabel()}
        checked={!value && value !== null}
        onClick={handleKeepPrivateClick}
      />
      {!workspaceIsDefined && !nonTeamSyncWorkspacesWithInitialTeammateIsOnlyOneOnOne && (
        <Collapse isOpen={expandedShareWithTeamOptions === false}>
          <div className="ml-4 mb-2 pl-1">
            <Field
              name="workspaceId"
              component={FormSelectWorkspace}
              nonTeamSyncWorkspacesWithInitialTeammate={nonTeamSyncWorkspacesWithInitialTeammate}
            />
          </div>
        </Collapse>
      )}
    </>
  );
}

export default createFormField(PublicOrPrivate);
